import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './BrandHeadingBlock';

const BrandHeadingSuspense = dynamic(() => import('./BrandHeadingBlock'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicBrandHeading(props: Props) {
	return <BrandHeadingSuspense {...props} />;
}
DynamicBrandHeading.displayName = 'DynamicBrandHeading';
